import React from 'react';
import { Check, X } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhoIsFor() {
  const isFor = ['Sentís que el cansancio acumulado ya te está afectando en todo: humor, paciencia, energía.', 'Querés ayudar a tu bebé a dormir mejor sin dejarlo llorar solo ni pasar por métodos duros.', 'Necesitás volver a funcionar de día, ya sea por trabajo, por tu familia o por vos misma.', 'Te gustaría recuperar tus noches y tener un poco más de tiempo para vos y tu pareja.'];
  const notFor = ['Buscás una solución instantánea sin dedicarle unos días de constancia y paciencia.', 'Preferís métodos donde el bebé llore solo hasta que se duerma, sin acompañamiento.'];
  return <section className="bg-beige py-24 px-6 md:px-12" data-id="element-170">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-171">
        <FadeIn direction="right" data-id="element-172">
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm h-full" data-id="element-173">
            <h3 className="text-3xl mb-8 text-brown" data-id="element-174">Esto es para vos si...</h3>
            <ul className="space-y-6" data-id="element-175">
              {isFor.map((item, i) => <li key={i} className="flex items-start space-x-4" data-id="element-176">
                  <div className="bg-green-100 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-177">
                    <Check className="w-5 h-5 text-green-600" strokeWidth={3} data-id="element-178" />
                  </div>
                  <span className="text-lg text-brown/80" data-id="element-179">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn direction="left" delay={0.2} data-id="element-180">
          <div className="bg-white/50 p-8 md:p-10 rounded-3xl border border-brown/10 h-full" data-id="element-181">
            <h3 className="text-3xl mb-8 text-brown/60" data-id="element-182">
              Esto NO es para vos si...
            </h3>
            <ul className="space-y-6" data-id="element-183">
              {notFor.map((item, i) => <li key={i} className="flex items-start space-x-4" data-id="element-184">
                  <div className="bg-red-100 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-185">
                    <X className="w-5 h-5 text-red-500" strokeWidth={3} data-id="element-186" />
                  </div>
                  <span className="text-lg text-brown/60" data-id="element-187">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}